export default __webpack_public_path__ + "static/media/QR Code-android.26bffddd.jpeg";